import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardHome from './pages/DashboardHome';
import SBPDashboard from './pages/SBPDashboard';
import LandRatesDashboard from './pages/LandRatesDashboard';
import LiquorDashboard from './pages/LiquorDashboard';
import RevTargetSettings from './pages/RevTargetSettings';
import CountyAnalysis from './pages/CountyAnalysis';
import SubCountyAnalysis from './pages/SubCountyAnalysis';
import UserMgt from './pages/UserMgt';
import ProtectedRoute from './ProtectedRoute';
import RevenueExecutiveDashboard from './pages/RevenueExecutiveDashboard';
import RevStreamInvoiceData from './pages/RevStreamInvoiceData';
import ManualRevenueDashboard from './pages/ManualRevenueDashboard';
import Login from './pages/Login';
import Layout from './components/layout/Layout';
import Unauthorized from './pages/Unauthorized';
import { all } from 'axios';

const App = () => {
  const allRoles = ['Operations Admin','Sub County Revenue Officer','Management Team','Executive','Board Member','System Administrator'];
  const execDashboardRoles = ['Executive', 'Management Team','Board Member','Operations Admin','System Administrator'];
  const ledgerDownloadRoles = ['Operations Admin','System Administrator'];
  const targetSettingsRoles = ['Operations Admin','Sub County Revenue Officer','System Administrator'];
  const userMgtRoles = ['System Administrator'];
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Routes wrapped with Layout */}
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={
            <ProtectedRoute 
            allowedRoles={allRoles}
            >
              <DashboardHome />
              </ProtectedRoute>} />
          <Route path="/execdashboard" element={
            <ProtectedRoute 
            allowedRoles={execDashboardRoles}
            >
              <RevenueExecutiveDashboard />
              </ProtectedRoute>} 
            />

          <Route path="/operations">
            <Route index element={<Navigate to="/operations/sbp" replace />} />
            <Route path="sbp" element={
              <ProtectedRoute
              allowedRoles={allRoles}
              >
                <SBPDashboard />
                </ProtectedRoute>} 
                />
            <Route path="liquor" element={
              <ProtectedRoute
              allowedRoles={allRoles}
              >
                <LiquorDashboard />
              </ProtectedRoute>} />
            <Route path="land" element={
              <ProtectedRoute
              allowedRoles={allRoles}
              >
                <LandRatesDashboard />
              </ProtectedRoute>} />
            <Route path="LedgerDownload" element={
              <ProtectedRoute 
                allowedRoles={ledgerDownloadRoles}
              >
                <RevStreamInvoiceData />
              </ProtectedRoute>}/>
              <Route path="ManualRev" element={
                <ProtectedRoute 
                allowedRoles={ledgerDownloadRoles}
              >
                <ManualRevenueDashboard />
              </ProtectedRoute>}/>
            {/* Future operations routes can be added here */}
          </Route>

          <Route path="/analysis">
            <Route index element={<Navigate to="/analysis/county" replace />} />
            <Route path="county" element={
              <ProtectedRoute 
                allowedRoles={execDashboardRoles}
              >
                <CountyAnalysis />
                </ProtectedRoute>}
                />
            <Route path="subcounty" element={
              <ProtectedRoute 
                allowedRoles={allRoles}
              >
                <SubCountyAnalysis />
                </ProtectedRoute>} 
                />
          </Route>
          <Route path="/settings">
            <Route index element={<Navigate to="/settings/targets" replace />} />
            <Route path="targets" element={
              <ProtectedRoute 
                allowedRoles={targetSettingsRoles}
              >
                <RevTargetSettings />
              </ProtectedRoute>
            } />
            <Route path="users" element={
              <ProtectedRoute 
                allowedRoles={userMgtRoles}
              >
                <UserMgt />
              </ProtectedRoute>
              } />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />}  />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />}  />
      </Routes>
    </Router>
  );
};

export default App;